// extracted by mini-css-extract-plugin
module.exports =  {"container":"container__duUpA","text":"text__xjd-n"};